import { render, staticRenderFns } from "./Survey.vue?vue&type=template&id=394205c8&scoped=true"
import script from "./Survey.vue?vue&type=script&lang=ts"
export * from "./Survey.vue?vue&type=script&lang=ts"
import style0 from "./Survey.vue?vue&type=style&index=0&id=394205c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394205c8",
  null
  
)

export default component.exports